import { router, routerFuns } from "sw-hic";
import { dictIndex, reportIndex } from "sw-hic-masterdata";
routerFuns.init(
  [
    {
      path: "/tmpl",
      name: "tmpl",
      component: () => import("@/components/tmpl/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/element",
      name: "element",
      component: () => import("@/components/ele/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/mrMain",
      name: "mrMain",
      component: () => import("@/components/mrMain/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/qc",
      name: "qc",
      component: () => import("@/components/qc/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/help",
      name: "help",
      component: () => import("@/components/help/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/dict",
      name: "dict",
      component: dictIndex,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report",
      name: "report",
      component: reportIndex,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/api",
      name: "api",
      component: () => import("@/components/metaApi/index"),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/register",
      name: "register",
      component: () => import("@/components/register/index"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
  [
    {
      path: "/studio",
      name: "studio",
      component: () => import("@/components/doctor/studio"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/sso",
      name: "sso",
      component: () => import("@/components/sso"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/view",
      name: "view",
      component: () => import("@/components/sso"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/editor",
      name: "editor",
      component: () => import("@/components/doctor/editor"),
      meta: {
        requiresAuth: false,
      },
    },
    {
      path: "/viewer",
      name: "viewer",
      component: () => import("@/components/view/viewer"),
      meta: {
        requiresAuth: false,
      },
    },
  ]
);

export default router;
